import Swiper from 'swiper';

const ArticlesSlider = () => {
  /* !----------------- SWIPER ------------------! */
  const containers = document.querySelectorAll('.page-section-articles-slider .swiper-container');

  if (!containers.length) return;

  containers.forEach(container => {
    new Swiper(container, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 4,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.custom-button-next',
        prevEl: '.custom-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  });
}

export default ArticlesSlider;